import { render } from "./videoPresentation1.vue?vue&type=template&id=950d7588&scoped=true"
import script from "./videoPresentation1.vue?vue&type=script&lang=js"
export * from "./videoPresentation1.vue?vue&type=script&lang=js"

import "./videoPresentation1.vue?vue&type=style&index=0&id=950d7588&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-950d7588"]])

export default __exports__